import { useNavigate } from 'react-router-dom';
import { formatDate, formatTime } from '../../Helpers/date-time-formatters';
import useTranslate from '../../Hooks/useTranslate';
import Button from '../../Style-guide/Button';
import Text from '../../Style-guide/Text';

const ReservationItem = ({ data, openModal }) => {
  const {
    startTime,
    endTime,
    status,
    court,
    allowRescheduling,
    id: reservationId,
  } = data;
  const tr = useTranslate();
  const navigate = useNavigate();

  const formattedDate = formatDate(new Date(startTime));
  const formattedStartTime = formatTime(new Date(startTime));
  const formattedEndTime = formatTime(new Date(endTime));
  const isCancelled = status === 'cancelled';
  const hasPassed = new Date(startTime) < new Date();
  const isDisabled = hasPassed || isCancelled;

  const handleRescheduleClick = () => {
    navigate(`/reserve-court/${court.id}?mode=reschedule&reservationId=${reservationId}`);
  };

  return (
    <div className='reservation-item'>
      <Text size='SM'>{court.name}</Text>
      <Text size='MD' className='reservation-time'>
        {`${formattedDate} ${formattedStartTime} - ${formattedEndTime}`}
      </Text>
      <div className='reservation-actions'>
        <span className={`reservation-status${isCancelled ? ' status-cancelled' : ''}`}>
          {isCancelled ? tr('cancelled') : tr('confirmed')}
        </span>
        <Button
          disabled={isDisabled}
          className='reservation-cancel-button'
          $negativeAction
          onClick={openModal}
        >
          {tr('cancel')}
        </Button>
      </div>
      {!isDisabled && allowRescheduling && (
        <Button className='reschedule-button' onClick={handleRescheduleClick}>
          {tr('reschedule')}
        </Button>
      )}
    </div>
  );
};

export default ReservationItem;
